import { useI18n } from 'vue-i18n'

import useBlProviders from '@/composables/providers/useBlProvider'
import WorkReportLinksDt from '@/services/dataTransferModules/workReportLinksDt'

export default function useWorkReportLinks(params = {}) {
	const workReportLinksDt = new WorkReportLinksDt()

	const { t: $t } = useI18n()

	const defaults = {
		creatingWorkReportLink: {
			title: '',
			description: '',
		},
		fieldsToPatch: ['title', 'description'],
	}

	const {
		loadEntityFlags: flags,

		entities: workReportLinks,
		getEntities: getWorkReportLinks,

		createEntity: createWorkReportLink,

		entity: workReportLink,
		getEntity: getWorkReportLink,

		patchEntity: putWorkReportLink,
		updateEntity: updateWorkReportLinks,

		deleteEntity: deleteWorkReportLink,
	} = useBlProviders(
		workReportLinksDt,
		Object.assign(
			{
				showErrorNotificationForLoadingAllEntities: true,
				errorNotificationTextForLoadingAllEntities: $t('Error loading reporting link type'),

				showErrorNotificationForCreatingEntity: true,
				errorNotificationTextForCreatingEntity: $t('Reporting link type creation error'),

				showErrorNotificationForLoadingOneEntity: true,

				showErrorNotificationForUpdatingEntity: true,
				errorNotificationTextForUpdatingEntity: $t('Reporting link type editing error'),

				showErrorNotificationForDeletingEntity: true,
				errorNotificationTextForDeletingEntity: $t('Failed to delete reporting link type'),
			},
			params,
		),
	)

	return {
		flags,
		defaults,
		workReportLinks,
		workReportLink,
		getWorkReportLinks,
		getWorkReportLink,
		createWorkReportLink,
		putWorkReportLink,
		updateWorkReportLinks,
		deleteWorkReportLink,
	}
}
